<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <span class="sa-flexbox-body-title">Parametri Vitali</span>
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template v-slot:cell(nominativo)="{ item }">
                            <span class="sa-table-span-label-primary">{{ item.cognome }} {{ item.nome }}</span>
                            <span class="sa-table-span-label-secondary">{{ item.identificativo }}</span>
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Modifica" variant="outline-success" @click="onClickEditParametroVitale(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>

            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <rsa-paziente-parametri-vitali-edit-modal-component ref="mdlRsaPazienteParametriVitaliEdit" @saveSuccess="onSaveSuccess"></rsa-paziente-parametri-vitali-edit-modal-component>
    </div>
</template>
<script>
// import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
// import axios from "axios";
import RsaPazienteParametriVitaliEditModalComponent from "./RsaPazienteParametriVitaliEditModalComponent.vue";
// import RsaPazienteParametriVitaliViewModalComponent from "./RsaPazienteParametriVitaliViewModalComponent.vue";
export default {
    props: {},
    watch: {
        currentPage() {
            let me = this;
            let filtro = {};
            filtro.idPaziente = me.idAccettazione;
            filtro.dataAl = new Date().getTime() + 24 * 60 * 60 * 1000;
            filtro.dataDal = filtro.dataAl - 30 * 24 * 60 * 60 * 1000;
            me.loadData();
        },
    },
    mixins: [UtilityMixin],
    components: { RsaPazienteParametriVitaliEditModalComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            listKey: 0,
            items: [],
            pathResource: "/rsaparametrivitalipianificazione/attivita",
            linkedit: "/",
            idPresidio: null,
            filterItems: [],
            filtroSpesaExtra: {},
            filtro: {},
            accettazione: {},
            parametriRaggruppati: {},
            colonneTabella: [],
            showModalLoading: false,
            idAccettazione: "",
            dateGroups: [],
            fields: [
                { key: "index", label: "*" },
                { key: "nominativo", label: "Nominativo" },
                { key: "ripetizioni", label: "Rilevamenti Da Effettuare" },
                { key: "rilevazioniEffettuate", label: "Rilevamenti Effettuati" },
                { key: "actions", label: "", class: "sa-table-column-action-double" },
            ],
        };
    },
    mounted() {},
    methods: {
        loadData(filtro) {
            let me = this;
            me.$emit("beforeLoadData");
            // console.log("Eccomi");
            me.filtro = filtro;
            me.idPresidio = filtro.idPresidio;
            this.loadDataResources(me.pathResource, { idPresidio: filtro.idPresidio }, me.loadDataSuccess, null);
        },

        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = me.items.length;
            me.$emit("afterLoadData");
        },
        loadDataError(response) {
            console.log(response);
        },
        onClickEditParametroVitale(item) {
            let me = this;
            me.$refs.mdlRsaPazienteParametriVitaliEdit.show(null, me.idPresidio, item.id);
        },
        // onClickDeleteParametriVitali(item) {
        //     let me = this;
        //     this.$bvModal
        //         .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", { title: "Eliminazione Parametri Vitali", buttonSize: "sm", okVariant: "secondary", cancelVariant: "danger", okTitle: "SI", cancelTitle: "NO", footerClass: "p-2", hideHeaderClose: false, centered: true })
        //         .then((value) => {
        //             if (value) {
        //                 me.deleteParametriVitali(item.id);
        //             }
        //         })
        //         .catch((err) => {
        //             console.log(err);
        //         });
        // },
        // deleteParametriVitali(id) {
        //     let me = this;
        //     me.showModalLoading = true;
        //     let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
        //     UtilityMixin.methods.restCallDelete(link, me.resultDeleteResponse, me.resultDeleteError);
        // },
        // resultDeleteResponse(response) {
        //     let me = this;
        //     me.$emit("onDelete", response);
        //     me.$bvToast.toast("Eliminazione avvenuta con successo", { title: "Successo", variant: "success", solid: true });
        //     me.loadData();
        // },
        // resultDeleteError(error) {
        //     let me = this;
        //     console.log(error);
        //     me.showModalLoading = false;
        //     me.$bvToast.toast("Errore durante l'eliminazione", { title: "Errore", variant: "danger", solid: true });
        // },
        // onClickView(item) {
        //     let me = this;
        //     me.$refs.mdlRsaPazienteParametriVitaliView.show(item.id);
        // },
        // onClickNuovaMisurazione() {
        //     let me = this;
        //     me.idAccettazione = this.$route.query.idAccettazione;

        //     let url = process.env.VUE_APP_PATH_API + "/rsaaccettazioni/" + me.idAccettazione;

        //     axios
        //         .get(url)
        //         .then((response) => {
        //             let accettazione = response.data.data;
        //             if (accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" || accettazione.statoAttuale === "ASSENTE") {
        //                 let messaggio = accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
        //                 me.$bvModal.msgBoxOk(messaggio, { title: "ATTENZIONE", size: "sm", okVariant: "outline-danger", headerClass: "sa-msg-header-danger", footerClass: "p-2 border-top-0", centered: true });
        //                 return;
        //             }
        //             me.$refs.mdlRsaPazienteParametriVitaliEdit.show(null, accettazione.idPresidio);
        //         })
        //         .catch((error) => {
        //             console.error("Errore nel recupero dati accettazione:", error);
        //             me.$bvToast.toast("Errore nel recupero dei dati del paziente.", { title: "Errore", variant: "danger", solid: true });
        //         });
        // },
        // saveSuccessResponse(response) {
        //     let me = this;
        //     me.$emit("sucessRestCall", response);
        //     me.$emit("onAfterSave");
        //     me.loadData();
        // },
        // saveErrorResponse(response) {
        //     let me = this;
        //     if (response.response.status === 400) {
        //         this.$bvModal.msgBoxOk(response.response.data.messaggio, { title: "ATTENZIONE", size: "sm", okVariant: "outline-danger", headerClass: "sa-msg-header-danger", footerClass: "p-2 border-top-0", centered: true });
        //     } else {
        //         me.$bvToast.toast("Errore nel salvataggio" + response.message, { title: "Errore", variant: "danger", solid: true });
        //     }
        // },
        onSaveSuccess() {
            let me = this;

            me.loadData(me.filtro);
        },
        // raggruppaParametriVitali(listaParametri) {
        //     const dati = listaParametri.map((m) => ({
        //         ts: Number(m.createDate),
        //         tipo: m.measurename,
        //         valore: m.value,
        //     }));
        //     const timestampOrdinati = [...new Set(dati.map((d) => d.ts))].sort((a, b) => b - a);
        //     const gruppiDiDate = [];
        //     let lastDate = null;

        //     const colonne = [
        //         {
        //             key: "index",
        //             label: " ",

        //             thStyle: {
        //                 width: "10px",
        //                 minWidth: "10px",
        //                 maxWidth: "10px",
        //                 padding: "0.2rem",
        //             },
        //             tdStyle: {
        //                 width: "10px",
        //                 minWidth: "10px",
        //                 maxWidth: "10px",
        //                 padding: "0.2rem",
        //             },
        //         },
        //         {
        //             key: "tipo",
        //             label: "Attività",
        //             thClass: "colonna-fissa-attivita align-middle text-left",
        //             tdClass: "colonna-fissa-attivita text-left",
        //             thStyle: {
        //                 width: "120px",
        //                 minWidth: "120px",
        //                 maxWidth: "120px",
        //                 padding: "0.3rem",
        //             },
        //             tdStyle: {
        //                 width: "120px",
        //                 minWidth: "120px",
        //                 maxWidth: "120px",
        //                 padding: "0.3rem",
        //             },
        //         },
        //         ...timestampOrdinati.map((ts) => {
        //             const dateObj = new Date(ts);
        //             const data = dateObj.toLocaleDateString("it-IT");
        //             const ora = dateObj.toLocaleTimeString("it-IT", {
        //                 hour: "2-digit",
        //                 minute: "2-digit",
        //             });

        //             const isNuovoGruppo = data !== lastDate;

        //             if (isNuovoGruppo) {
        //                 gruppiDiDate.push({ date: data, count: 1 });
        //                 lastDate = data;
        //             } else {
        //                 gruppiDiDate[gruppiDiDate.length - 1].count++;
        //             }

        //             return {
        //                 key: ts.toString(),
        //                 label: ora,
        //                 thClass: `text-center align-middle${isNuovoGruppo ? " sa-bordo-gruppo" : ""}`,
        //                 tdClass: `text-center align-middle${isNuovoGruppo ? " sa-bordo-gruppo" : ""}`,
        //                 thStyle: { minWidth: "150px" },
        //                 tdStyle: { minWidth: "150px" },
        //             };
        //         }),
        //     ];

        //     this.dateGroups = gruppiDiDate;
        //     this.fields = colonne;
        //     const righeTemporanee = dati.reduce((acc, { ts, tipo, valore }) => {
        //         if (!acc[tipo]) {
        //             acc[tipo] = { tipo };
        //         }
        //         acc[tipo][ts] = valore;
        //         return acc;
        //     }, {});

        //     this.items = Object.values(righeTemporanee);
        // },
    },
};
</script>
<style></style>
